import React from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {Link} from "react-router-dom"
import {MoneyNav} from "./MoneyNav";
import {getMoneyPathBack} from "../functions"

export class ViewWindowPurchase extends React.Component {

    render() {

        const {title, totalOfPeriod, averageOfPeriod, currency, show, setShow, purchases, setPurchases, dataNav} = this.props

        const closeHandler = () => {
            setPurchases([])
            setShow(false)
        }

        return (
            <>
                <MoneyNav dataNav={dataNav}/>
                <Modal id={"modal-view-purchases"} show={show}>
                    <Modal.Header>
                        <div className={'d-flex w-100 flex-wrap justify-content-end'}>
                            <div className={'d-flex w-100 flex-nowrap'}>
                                <Modal.Title className={'w-100 text-start fs-5 fst-italic'}>{`Всего за ${title}: ${totalOfPeriod} (${currency})`}</Modal.Title>
                                <div className={'d-flex align-items-start'}>
                                    <Link to={getMoneyPathBack()}>
                                        <Button className={'ms-2'} variant={"close"} onClick={closeHandler}/>
                                    </Link>
                                </div>
                            </div>
                            {averageOfPeriod !== 0 && <div className={'d-flex w-100 flex-nowrap'}>
                                <Modal.Title className={'w-100 text-start fs-5 fst-italic'}>{`В среднем за день: ${averageOfPeriod} (${currency})`}</Modal.Title>
                            </div>}
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{maxHeight: "80vh", overflowY: "auto"}}>
                        <div className={'col border border-3 rounded-2 m-2 ps-2 pe-2 pt-3 pb-3'}>
                            <div id={'div-expenses-month'} className={'add-expense ps-2 pe-2'}>
                                {purchases.map((pur, index) => {
                                    const nameCat = pur.name
                                    const value = pur.value
                                    if (nameCat !== 'total') {
                                        return (
                                            <div id={`expense-row-${index}`} className={'row m-1 mt-3'}
                                                 key={index}>
                                                <div id={`expense-div-${index}`}
                                                     className={'col col-12 d-flex justify-content-between border-bottom'}>
                                                    <h6 id={`expense-name-${index}`}
                                                        className={'m-0'}>{nameCat}</h6>
                                                    <p id={`expense-value-${index}`}
                                                       className={'m-0'}>{`${value} (${currency})`}</p>
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (<></>)
                                    }

                                })}
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer/>
                </Modal>
            </>
        )
    }
}